module.exports = __webpack_public_path__ + "static/media/bg-meeting-filter.8696e9fe.webp";